module.exports = __webpack_public_path__ + "static/media/mlang_green.7b6388fe.png";